<template>
  <div class="sidepanel-appearance">
    <div
      class="panel-section-header text-panel-section-header mt-2 d-flex logo-manager-parent align-items-center"
      v-on:click="diplayAppearanceDetails = !diplayAppearanceDetails"
    >
      <div class="flex-column">
        {{ $t('options.sectionAppearance') }}
      </div>
      <div class="backgroundButton flex-column">
        <font-awesome-icon
          :icon="
            diplayAppearanceDetails
              ? ['fas', 'chevron-up']
              : ['fas', 'chevron-down']
          "
        />
      </div>
    </div>
    <!-- <template v-if="diplayAppearanceDetails"> </template> -->
    <template v-if="diplayAppearanceDetails">
      <div @click="selectBGImage" class="d-flex pointer">
        <div class="d-flex flex-column justify-content-center">
          <span class="text-weight-semi-bold">
            {{ $t('options.backgroundImage') }}
          </span>
          <div class="text-size-10 pt-0 toggle-description text-primary">
            {{ $t('options.backgroundImageTip') }}
          </div>
        </div>
        <img
          class="ml-auto mr-2 flex-column border-radius"
          height="50"
          :src="backgroundImageThumnail"
        />
        <div class="backgroundButton flex-column">
          <icon class="h3 text-primary mt-1" type="nextButton" />
        </div>
      </div>
      <div class="sidepanel-separator mt-2"></div>

      <!-- hide toggle if the template is custom, display when the template is default. -->
      <ToggleOption
        v-model="darkMode"
        icon="edit"
        class="my-2"
        v-if="getSelectedTemplate.isDefault == 1"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.darkMode') }}
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.darkModeTip') }}
        </div>
      </ToggleOption>
      <div
        class="sidepanel-separator mt-2"
        v-if="getSelectedTemplate.isDefault == 1"
      ></div>
      <!-- ------ -->

      <!-- This is the label and image design for custom branding, if you want to use the dropdown uncomment the below code. -->
      <div
        class="d-flex pointer logo-manager-parent mt-2"
        @click="openCustomBranding"
      >
        <div class="d-flex flex-column justify-content-center">
          <span class="text-weight-semi-bold">
            {{ $t('customLogo.header') }}
            <label class="col-2 col-form-label new-premium-label">
              {{ $t('options.new') }}
            </label>
            <img
              class="ml-1 mr-2 flex-column border-radius premium-logo-design"
              height="50"
              srcset="/images/PremiumFavicon.png"
              alt=""
            />
          </span>
          <div class="text-size-10 pt-0 toggle-description">
            {{ $t('customLogo.description') }}
          </div>
        </div>
        <!-- End of label part -------- -->

        <!-- ----- End of Drop down part--- -->
        <div class="a-self logo-image-update flex-column">
          <img
            v-if="0"
            class="ml-auto mr-2 flex-column border-radius custom-logo-image"
            height="50"
            srcset="../../assets/logo_neu_weiss_blau_orange.png 2x"
            alt=""
          />
          <icon class="h3 text-primary mt-1" type="nextButton" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ToggleOption from '@/components/Edit/ToggleOption.vue';

import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import { dateMixin } from '@/components/mixins/DateMixins.js';
import { renderMixin } from '../mixins/RenderMixins';

import { mapState, mapGetters, mapActions } from 'vuex';
import Icon from '../UI/Icon.vue';

import { extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';

// import CustomBrandingTemplates from './CustomBrandingTemplates.vue';
const customTemplate = require('../../shared/customTemplate');

extend('required', required);
localize('en', en);

export default {
  name: 'EditKulibri',

  props: ['backup'],
  mixins: [formValidationMixin, dateMixin, renderMixin],

  components: {
    ToggleOption,
    Icon,
  },

  data() {
    return {
      diplayAppearanceDetails: false,
    };
  },

  methods: {

    ...mapActions(['updateSelectedTemplate', 'updateDesignIdInPoll', 'loadDesign']),

    selectBGImage() {
      console.info("EditPollApearance - selectBGImage");  
      this.$emit('change');
    },

    openCustomBranding() {
      console.info("EditPollApearance - openCustomBranding");  
      this.$emit('openCustomBranding');
    },

    updateDesignTemplate(modeValue) {
      let darkModeString = modeValue == true ? 'dark' : 'light';
      // this.updateSelectedTemplate(response.data.design);
      for (let i = 0; i < this.designs.length; i++) {
        if (
          this.designs[i]['isDefault'] == true &&
          this.designs[i]['name'].includes(darkModeString)
        ) {
          this.updateSelectedTemplate(this.designs[i]);
          if (darkModeString == 'dark') {
            customTemplate.updateDarkModeOpacity(
              this.designs[i].config.answerGridSection.darkModeOpacity / 100
            );
          } else {
            customTemplate.updateLighModeOpacity(
              this.designs[i].config.answerGridSection.darkModeOpacity / 100
            );
          }
          // customTemplate.renderHTML(this.designs[i]);
          break;
        }
        // if(this.designs[i]['id'] == this.poll.design_id) {
        //   this.$refs.refBrandingTemplate.updateTemplate(this.designs[i]);
        //   this.$refs.refBrandingTemplate.renderValue();
        //   break;
        // }
      }
    },
  },
  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),

    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      isPremium: 'isPremium',
      getSelectedTemplate: 'getSelectedTemplate',
      designs: 'designs',
    }),



    backgroundImageThumnail() {
      return '/images/background_default_thumnail.jpg';
    },

    darkMode: {
      get() {
        if (this.poll.options.darkMode == null) return false;
        return this.poll.options.darkMode;
      },
      set(value) {
        if(this.designs.length == 0) {
            this.loadDesign().then(() => {
              this.$store.commit('updateDarkMode', value);
              this.updateDesignTemplate(value);
            });
        } else {
          this.$store.commit('updateDarkMode', value);
          this.updateDesignTemplate(value);
        }
      },
    },

  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';

.a-self {
  align-self: center;
}

.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 32px;
  margin-bottom: 8px;
  margin-top: 0px;
  line-height: 20px;
  margin-left: -16px;
  margin-right: -16px;
}

.backgroundButton {
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.toggle-description {
  color: $mid-grey;
}

.custom-logo-image {
  width: 40px;
  height: 40px;
  background: #1d1d1d;
  object-fit: contain;
}

.logo-manager-parent {
  cursor: pointer;
  justify-content: space-between;
  .logo-image-update {
    display: block;
  }
  // label, button {
  //   word-break: break-word;
  //   white-space: normal;
  //   width: 100px;
  //   color: $primary;
  // }
}
</style>
